/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { AuthEmailConfirmReq } from '../_model/authEmailConfirmReq';
import type { AuthEmailReq } from '../_model/authEmailReq';
import type { AuthorizationForGoogleTokenRequest } from '../_model/authorizationForGoogleTokenRequest';
import type { GoogleAuthorizationCallbackParams } from '../_model/googleAuthorizationCallbackParams';
import type { SuccessBodyAuthEmailRes } from '../_model/successBodyAuthEmailRes';
import type { SuccessBodyAuthResWithPlanType } from '../_model/successBodyAuthResWithPlanType';
import type { SuccessBodyMapStringString } from '../_model/successBodyMapStringString';
import type { SuccessBodyString } from '../_model/successBodyString';
import type { WhalespaceCallbackParams } from '../_model/whalespaceCallbackParams';
import type { WhalespaceV2CallbackParams } from '../_model/whalespaceV2CallbackParams';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const requestEmailLoginCode = (
  authEmailReq: BodyType<AuthEmailReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyAuthEmailRes>(
    {
      url: `/login/email`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: authEmailReq,
      signal,
    },
    options,
  );
};

export const getRequestEmailLoginCodeMutationKey = () =>
  ['requestEmailLoginCode'] as const;

export const getRequestEmailLoginCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestEmailLoginCode>>,
    TError,
    RequestEmailLoginCodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestEmailLoginCode>>,
  TError,
  RequestEmailLoginCodeMutationVariables,
  TContext
> => {
  const mutationKey = getRequestEmailLoginCodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestEmailLoginCode>>,
    RequestEmailLoginCodeMutationVariables
  > = props => {
    const { data } = props ?? {};

    return requestEmailLoginCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestEmailLoginCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestEmailLoginCode>>
>;
export type RequestEmailLoginCodeMutationBody = BodyType<AuthEmailReq>;
export type RequestEmailLoginCodeMutationError = ErrorType<unknown>;
export type RequestEmailLoginCodeMutationVariables = {
  data: BodyType<AuthEmailReq>;
};

export const useRequestEmailLoginCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestEmailLoginCode>>,
      TError,
      RequestEmailLoginCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestEmailLoginCode>>,
  TError,
  RequestEmailLoginCodeMutationVariables,
  TContext
> => {
  return useMutation(
    getRequestEmailLoginCodeMutationOptions(options),
    queryClient,
  );
};
export const confirmEmailLogin = (
  authEmailConfirmReq: BodyType<AuthEmailConfirmReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyAuthResWithPlanType>(
    {
      url: `/login/email/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: authEmailConfirmReq,
      signal,
    },
    options,
  );
};

export const getConfirmEmailLoginMutationKey = () =>
  ['confirmEmailLogin'] as const;

export const getConfirmEmailLoginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmEmailLogin>>,
    TError,
    ConfirmEmailLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmEmailLogin>>,
  TError,
  ConfirmEmailLoginMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmEmailLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmEmailLogin>>,
    ConfirmEmailLoginMutationVariables
  > = props => {
    const { data } = props ?? {};

    return confirmEmailLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmEmailLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmEmailLogin>>
>;
export type ConfirmEmailLoginMutationBody = BodyType<AuthEmailConfirmReq>;
export type ConfirmEmailLoginMutationError = ErrorType<unknown>;
export type ConfirmEmailLoginMutationVariables = {
  data: BodyType<AuthEmailConfirmReq>;
};

export const useConfirmEmailLogin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmEmailLogin>>,
      TError,
      ConfirmEmailLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmEmailLogin>>,
  TError,
  ConfirmEmailLoginMutationVariables,
  TContext
> => {
  return useMutation(getConfirmEmailLoginMutationOptions(options), queryClient);
};
export const getTokenAndGoogleAccessTokenByAuthorizationCode = (
  authorizationForGoogleTokenRequest: BodyType<AuthorizationForGoogleTokenRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyMapStringString>(
    {
      url: `/auth/google/token`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: authorizationForGoogleTokenRequest,
      signal,
    },
    options,
  );
};

export const getGetTokenAndGoogleAccessTokenByAuthorizationCodeMutationKey =
  () => ['getTokenAndGoogleAccessTokenByAuthorizationCode'] as const;

export const getGetTokenAndGoogleAccessTokenByAuthorizationCodeMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>
      >,
      TError,
      GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>,
    TError,
    GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationVariables,
    TContext
  > => {
    const mutationKey =
      getGetTokenAndGoogleAccessTokenByAuthorizationCodeMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>
      >,
      GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationVariables
    > = props => {
      const { data } = props ?? {};

      return getTokenAndGoogleAccessTokenByAuthorizationCode(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>
  >;
export type GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationBody =
  BodyType<AuthorizationForGoogleTokenRequest>;
export type GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationError =
  ErrorType<unknown>;
export type GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationVariables = {
  data: BodyType<AuthorizationForGoogleTokenRequest>;
};

export const useGetTokenAndGoogleAccessTokenByAuthorizationCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>
      >,
      TError,
      GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>,
  TError,
  GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationVariables,
  TContext
> => {
  return useMutation(
    getGetTokenAndGoogleAccessTokenByAuthorizationCodeMutationOptions(options),
    queryClient,
  );
};
export const refreshGoogleAccessToken = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyString>(
    { url: `/auth/google/refresh-token`, method: 'POST', signal },
    options,
  );
};

export const getRefreshGoogleAccessTokenMutationKey = () =>
  ['refreshGoogleAccessToken'] as const;

export const getRefreshGoogleAccessTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshGoogleAccessToken>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshGoogleAccessToken>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getRefreshGoogleAccessTokenMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshGoogleAccessToken>>,
    void
  > = () => {
    return refreshGoogleAccessToken(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshGoogleAccessTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshGoogleAccessToken>>
>;

export type RefreshGoogleAccessTokenMutationError = ErrorType<unknown>;

export const useRefreshGoogleAccessToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshGoogleAccessToken>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshGoogleAccessToken>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getRefreshGoogleAccessTokenMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary [Deprecated] Whalespace OAuth v2 OIDC Callback
 */
export const whalespaceV2Callback = (
  params: WhalespaceV2CallbackParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<unknown>(
    { url: `/auth/whalespace/v2/callback`, method: 'GET', params, signal },
    options,
  );
};

export const getWhalespaceV2CallbackQueryKey = (
  params?: WhalespaceV2CallbackParams,
) => {
  return [`/auth/whalespace/v2/callback`, ...(params ? [params] : [])] as const;
};

export const getWhalespaceV2CallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWhalespaceV2CallbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof whalespaceV2Callback>>
  > = ({ signal }) => whalespaceV2Callback(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof whalespaceV2Callback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WhalespaceV2CallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof whalespaceV2Callback>>
>;
export type WhalespaceV2CallbackQueryError = ErrorType<unknown>;

export function useWhalespaceV2Callback<
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof whalespaceV2Callback>>,
          TError,
          Awaited<ReturnType<typeof whalespaceV2Callback>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhalespaceV2Callback<
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof whalespaceV2Callback>>,
          TError,
          Awaited<ReturnType<typeof whalespaceV2Callback>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhalespaceV2Callback<
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary [Deprecated] Whalespace OAuth v2 OIDC Callback
 */

export function useWhalespaceV2Callback<
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWhalespaceV2CallbackQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getWhalespaceV2CallbackSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWhalespaceV2CallbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof whalespaceV2Callback>>
  > = ({ signal }) => whalespaceV2Callback(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof whalespaceV2Callback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type WhalespaceV2CallbackSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof whalespaceV2Callback>>
>;
export type WhalespaceV2CallbackSuspenseQueryError = ErrorType<unknown>;

export function useWhalespaceV2CallbackSuspense<
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhalespaceV2CallbackSuspense<
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhalespaceV2CallbackSuspense<
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary [Deprecated] Whalespace OAuth v2 OIDC Callback
 */

export function useWhalespaceV2CallbackSuspense<
  TData = Awaited<ReturnType<typeof whalespaceV2Callback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceV2CallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceV2Callback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWhalespaceV2CallbackSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @deprecated
 * @summary [Deprecated] Whalespace OAuth v1 Callback
 */
export const whalespaceCallback = (
  params: WhalespaceCallbackParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<unknown>(
    { url: `/auth/whalespace/callback`, method: 'GET', params, signal },
    options,
  );
};

export const getWhalespaceCallbackQueryKey = (
  params?: WhalespaceCallbackParams,
) => {
  return [`/auth/whalespace/callback`, ...(params ? [params] : [])] as const;
};

export const getWhalespaceCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWhalespaceCallbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof whalespaceCallback>>
  > = ({ signal }) => whalespaceCallback(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof whalespaceCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WhalespaceCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof whalespaceCallback>>
>;
export type WhalespaceCallbackQueryError = ErrorType<unknown>;

export function useWhalespaceCallback<
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof whalespaceCallback>>,
          TError,
          Awaited<ReturnType<typeof whalespaceCallback>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhalespaceCallback<
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof whalespaceCallback>>,
          TError,
          Awaited<ReturnType<typeof whalespaceCallback>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhalespaceCallback<
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 * @summary [Deprecated] Whalespace OAuth v1 Callback
 */

export function useWhalespaceCallback<
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWhalespaceCallbackQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getWhalespaceCallbackSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWhalespaceCallbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof whalespaceCallback>>
  > = ({ signal }) => whalespaceCallback(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof whalespaceCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type WhalespaceCallbackSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof whalespaceCallback>>
>;
export type WhalespaceCallbackSuspenseQueryError = ErrorType<unknown>;

export function useWhalespaceCallbackSuspense<
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhalespaceCallbackSuspense<
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhalespaceCallbackSuspense<
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 * @summary [Deprecated] Whalespace OAuth v1 Callback
 */

export function useWhalespaceCallbackSuspense<
  TData = Awaited<ReturnType<typeof whalespaceCallback>>,
  TError = ErrorType<unknown>,
>(
  params: WhalespaceCallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whalespaceCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWhalespaceCallbackSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Google OAuth callback - Use Auth Server instead
 * @summary [Deprecated] Google OAuth Callback
 */
export const googleAuthorizationCallback = (
  params: GoogleAuthorizationCallbackParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<unknown>(
    { url: `/auth/google/callback`, method: 'GET', params, signal },
    options,
  );
};

export const getGoogleAuthorizationCallbackQueryKey = (
  params?: GoogleAuthorizationCallbackParams,
) => {
  return [`/auth/google/callback`, ...(params ? [params] : [])] as const;
};

export const getGoogleAuthorizationCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGoogleAuthorizationCallbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof googleAuthorizationCallback>>
  > = ({ signal }) =>
    googleAuthorizationCallback(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof googleAuthorizationCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GoogleAuthorizationCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof googleAuthorizationCallback>>
>;
export type GoogleAuthorizationCallbackQueryError = ErrorType<unknown>;

export function useGoogleAuthorizationCallback<
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof googleAuthorizationCallback>>,
          TError,
          Awaited<ReturnType<typeof googleAuthorizationCallback>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGoogleAuthorizationCallback<
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof googleAuthorizationCallback>>,
          TError,
          Awaited<ReturnType<typeof googleAuthorizationCallback>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGoogleAuthorizationCallback<
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary [Deprecated] Google OAuth Callback
 */

export function useGoogleAuthorizationCallback<
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGoogleAuthorizationCallbackQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGoogleAuthorizationCallbackSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGoogleAuthorizationCallbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof googleAuthorizationCallback>>
  > = ({ signal }) =>
    googleAuthorizationCallback(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof googleAuthorizationCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GoogleAuthorizationCallbackSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof googleAuthorizationCallback>>
>;
export type GoogleAuthorizationCallbackSuspenseQueryError = ErrorType<unknown>;

export function useGoogleAuthorizationCallbackSuspense<
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGoogleAuthorizationCallbackSuspense<
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGoogleAuthorizationCallbackSuspense<
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary [Deprecated] Google OAuth Callback
 */

export function useGoogleAuthorizationCallbackSuspense<
  TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>,
  TError = ErrorType<unknown>,
>(
  params: GoogleAuthorizationCallbackParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof googleAuthorizationCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGoogleAuthorizationCallbackSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
